module.exports = __webpack_public_path__ + "static/img/WebAI.82b659a0.png";